/**
 * ProfessocialPost unterscheidet die Templates und stellt alle Module dafür bereit
 */

import React from 'react'

import { PostConfiguration } from '@professocial/professocialTypes/types/configurationTypes'
import {
  ScreenEnum,
  ViewEnum,
} from '@professocial/professocialTypes/types/commonTypes'

import FacebookPostTemplate from './subScreens/Facebook/FacebookPostTemplate'
import InstagramPostTemplate from './subScreens/Instagram/InstagramPostTemplate'
import PostsTemplate from './subScreens/TemplatePost/PostsTemplate'
import GoogleMyBusinessPostTemplate from './subScreens/GoogleMyBusiness/GoogleMyBusinessPostTemplate'
import { PublishedPostWithPostContent } from '@3m5/sm_publish-frontend-api'
import { NetworkType } from '@3m5/sm_publish-frontend-api'
import { EUserRole } from '@professocialApi/professocial-core-frontend-api'
import LinkedInPostTemplate from './subScreens/LinkedIn/LinkedInPostTemplate'

export interface IPostProps {
  postConfiguration?: PostConfiguration
}

const ProfessocialPost: React.FC<IPostProps> = (props: IPostProps) => {
  const userRole: EUserRole = props.postConfiguration?.userRole || EUserRole.User
  const view: ViewEnum = props.postConfiguration?.view || ViewEnum.overview
  const size: ScreenEnum = props.postConfiguration?.size || ScreenEnum.xl
  const networkType: NetworkType = props.postConfiguration?.networkType || NetworkType.Facebook

  const post = props.postConfiguration?.post
  const posting = props.postConfiguration?.posting
  const deferredPost = props.postConfiguration?.deferredPost
  const publishedPost: PublishedPostWithPostContent | undefined = props.postConfiguration?.publishedPost

  return (
    <>
      {networkType === NetworkType.Facebook && (props.postConfiguration?.facebookPost || posting) &&
        <FacebookPostTemplate
          userRole={userRole}
          view={view}
          size={size}
          networkPageId={props.postConfiguration?.networkPageId}
          post={props.postConfiguration?.facebookPost || posting}
          networkType={NetworkType.Facebook}
          onEditFeed={props.postConfiguration?.onEditFeed}
        />}
      {networkType === NetworkType.Instagram && (props.postConfiguration?.instagramPost || posting) &&
        <InstagramPostTemplate
          userRole={userRole}
          view={view}
          size={size}
          networkPageId={props.postConfiguration?.networkPageId}
          post={props.postConfiguration?.instagramPost || posting}
          networkType={NetworkType.Instagram}
          width={props.postConfiguration?.elementSize}
        />}
      {networkType === NetworkType.LinkedIn && (props.postConfiguration?.linkedInPost || posting) &&
        <LinkedInPostTemplate
          userRole={userRole}
          view={view}
          size={size}
          networkPageId={props.postConfiguration?.networkPageId}
          page={props.postConfiguration?.linkedInPage}
          post={props.postConfiguration?.linkedInPost || posting}
          networkType={NetworkType.LinkedIn}
          onEditFeed={props.postConfiguration?.onEditFeed}
        />}
      {networkType === NetworkType.GoogleMyBusiness && (props.postConfiguration?.googleMyBusinessPost || posting) &&
        <GoogleMyBusinessPostTemplate
          userRole={userRole}
          size={size}
          networkUserId={props.postConfiguration?.networkUserId || ''}
          networkPageId={props.postConfiguration?.networkPageId || ''}
          post={props.postConfiguration?.googleMyBusinessPost || posting}
          onEditFeed={props.postConfiguration?.onEditFeed && props.postConfiguration.onEditFeed}
          networkType={NetworkType.GoogleMyBusiness}
        />}
      {(post || deferredPost || publishedPost) &&
        <PostsTemplate
          userRole={userRole}
          view={props.postConfiguration?.view}
          size={size}
          filterType={props.postConfiguration?.filterType}
          networkPageId={props.postConfiguration?.networkPageId || ''}
          post={post}
          deferredPost={deferredPost}
          publishedPost={publishedPost}
        />}
    </>
  )
}
export default ProfessocialPost
